import React from 'react';
import { useBranding } from '@/lib/BrandingContext';

export default function AppearanceSwitch() {
  const { theme, changeTheme, disabled, saving } = useBranding();
  return <div className="appearance-switch py-2">
    <span className="sr-only" aria-live="polite">{saving ? 'Saving appearance' : ''}</span>
    <div role="group" aria-label="Appearance" className="appearance-options">
      {[['modern', 'New'], ['legacy', 'Legacy']].map(([value, label]) =>
        <button key={value} type="button" aria-pressed={theme === value} disabled={disabled}
          onClick={() => changeTheme(value)}>{label}</button>)}
    </div>
  </div>;
}
